import { css } from "@compiled/react";

import { PageTreeNodeData } from "@/patterns/agile-overview-sidenav/src";

import { SocialShareMenu } from "./social-share-menu";
import { AgileUpNextLink, type AgileUpNextLinkProps } from "./up-next-link";
import { useNextPage } from "./use-next-page";

export type AgileShareUpNextProps = {
    description?: string | null;
    link?: string | null;
    title?: string | null;
    source?: string | null;
    defaultNextPage: AgileUpNextLinkProps;
    pageTree: PageTreeNodeData[];
};

const AgileShareUpNextContainerStyle = css({
    display: "flex",
    backgroundColor: "#fff",
    minHeight: "74px",
    flexWrap: "wrap",
    verticalAlign: "baseline"
});

const ColumnStyles = css({
    display: "flex",
    width: "50%",
    flexDirection: "column",
    float: "left",
    padding: "0 20px 0 20px",
    position: "relative",
    margin: "auto"
});

export const AgileShareUpNext = ({
    defaultNextPage,
    pageTree,
    description,
    link,
    title,
    source
}: AgileShareUpNextProps) => {
    const nextPage = useNextPage(defaultNextPage, pageTree);
    return (
        <div css={AgileShareUpNextContainerStyle}>
            <div css={ColumnStyles}>
                {(description && link && title && (
                    <SocialShareMenu
                        description={description}
                        link={link}
                        title={title}
                        source={source}
                    />
                )) || <span />}
            </div>
            <div css={ColumnStyles}>
                <AgileUpNextLink {...nextPage} />
            </div>
        </div>
    );
};
